<div class="footer-container">
  <div class="footer-content">
    <div class="footer-grid">
      <div class="footer-section">
        <h3 class="footer-heading">Get To Know Us</h3>
        <ul class="footer-links">
<!--          <li><a routerLink="/about-us">About Us</a></li>-->
          <li><a routerLink="/contact-us">Contact Us</a></li>
          <li><a routerLink="/our-company">Our Company</a></li>
          <li><a routerLink="/faqs">Help & FAQs</a></li>
        </ul>
      </div>

      <div class="footer-section">
        <h3 class="footer-heading">Policies</h3>
        <ul class="footer-links">
          <li><a routerLink="/shipping-policy">Shipping Policy</a></li>
          <li><a routerLink="/cookies-policy">Cookies Policy</a></li>
          <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
          <li><a routerLink="/cancellation-policy">Cancellation Policy</a></li>
          <li><a routerLink="/fraud-disclaimer">Fraud Disclaimer</a></li>
          <li><a routerLink="/terms-and-conditions">Terms & Conditions</a></li>
        </ul>
      </div>

      <div class="footer-section app-section">
        <h3 class="footer-heading">Download Our App</h3>
        <div class="app-download-grid">
          <div class="store-item">
            <div class="qr-wrapper">
              <img alt="Android QR" src="images/Android.webp" width="100" height="100" loading="lazy">
              <span class="qr-label">Android</span>
            </div>
            <a class="store-badge" href="https://play.google.com/store/apps/details?id=com.viindhyagroup.viindhyagold" target="_blank">
              <img alt="Google Play" src="images/googleplay.webp" width="140" height="42" loading="lazy">
            </a>
          </div>
          <div class="store-item">
            <div class="qr-wrapper">
              <img alt="iOS QR" src="images/Apple.webp" width="100" height="100" loading="lazy">
              <span class="qr-label">iOS</span>
            </div>
            <a class="store-badge" href="https://apps.apple.com/in/app/viindhya-gold/id6751223959" target="_blank">
              <img alt="App Store" src="images/applestore.webp" width="140" height="42" loading="lazy">
            </a>
          </div>
        </div>
      </div>

      <div class="footer-section newsletter-section">
        <h3 class="footer-heading">Stay Connected</h3>
        <p class="newsletter-text">Subscribe to our channels for the latest updates and offers.</p>
        <div class="social-links-wrapper">
          <a class="social-link facebook" href="https://www.facebook.com/TheViindhyaGold" target="_blank" aria-label="Facebook">
            <img src="images/f.webp" alt="Facebook" width="32" height="32">
          </a>
          <a class="social-link instagram" href="https://www.instagram.com/viindhyagold" target="_blank" aria-label="Instagram">
            <img src="images/i.webp" alt="Instagram" width="32" height="32">
          </a>
          <a class="social-link linkedin" href="https://www.linkedin.com/company/viindhyabullion/" target="_blank" aria-label="LinkedIn">
            <img src="images/l.webp" alt="LinkedIn" width="32" height="32">
          </a>
          <a class="social-link youtube" href="https://www.youtube.com/@ViindhyaGold" target="_blank" aria-label="YouTube">
            <img src="images/y.webp" alt="YouTube" width="32" height="32">
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bottom-bar">
      <div class="bottom-left">
        <span class="copyright-text">&copy; {{ currentDate | date: 'y' }} <a href="https://viindhyagroup.com/" target="_blank" class="company-link">VIINDHYA GROUP</a>. All rights reserved.</span>
      </div>
      <div class="bottom-right" *ngIf="version">
        <span class="version-tag">Application Version : {{ version }}</span>
      </div>
    </div>
  </div>
</div>
